/**
 * Компонент для отслеживания SPA-переходов
 * Отправляет page_view события в GA4 и Яндекс.Метрику при навигации
 */
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'

import { analytics } from './analytics'
import { getGAId, getYMId, isDebugMode } from './config'
import { hasAnalyticsConsent } from './consent'

export default function PageViewTracker () {
  const location = useLocation()
  const isFirstRender = useRef(true)
  const isMounted = useRef(true)

  // Cleanup при размонтировании
  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    try {
      // Пропускаем первый рендер — page_view уже отправлен при загрузке страницы
      if (isFirstRender.current) {
        isFirstRender.current = false
        return
      }

      // Проверяем, что компонент все еще смонтирован
      if (!isMounted.current) {
        return
      }

      // Проверяем инициализацию аналитики и согласие пользователя
      if (!analytics.isInitialized()) {
        if (isDebugMode()) {
          console.log('[PageViewTracker] Analytics not initialized, skipping')
        }
        return
      }

      if (!hasAnalyticsConsent()) {
        if (isDebugMode()) {
          console.log('[PageViewTracker] No consent, skipping page view')
        }
        return
      }

      const url = location.pathname + location.search
      const gaId = getGAId()
      const ymId = getYMId()

      // Google Analytics 4
      if (typeof window.gtag === 'function' && gaId) {
        try {
          window.gtag('event', 'page_view', {
            page_path: url,
            page_location: window.location.href,
            page_title: document.title,
          })
        }
        catch (error) {
          console.error('[PageViewTracker] GA4 error:', error)
        }
      }

      // Яндекс.Метрика
      if (typeof window.ym === 'function' && ymId) {
        try {
          window.ym(ymId, 'hit', url, {
            title: document.title,
          })
        }
        catch (error) {
          console.error('[PageViewTracker] YM error:', error)
        }
      }
    }
    catch (error) {
      console.error('[PageViewTracker] Unexpected page_view tracking error:', error)
    }
  }, [ location.pathname, location.search ])

  return null
}
